import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import { state } from './state';

const payment = {
  actions,
  getters,
  mutations,
  state,
};

export default payment;
